module.exports = __webpack_public_path__ + "static/BC_RPA_logo-d73f79a4ea06ae0a9549b1c9b936259b.png";